import { useQuery } from '@tanstack/react-query'
import { PlaylistType } from 'sdk/types.d';
import { PostgrestSingleResponse } from '@supabase/supabase-js'
import { supabase } from '../api'

type CategoryPlaylistType = {
  id: number,
  playlist: PlaylistType | PlaylistType[],
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getPlaylists = async (categoryId: number, type?: string): Promise<PlaylistType[]> => {
  let req = supabase
    .from('playlists_categories')
    .select(`
      id,
      playlist:playlists (id, name, type)
    `)
    .eq('category_id', categoryId)

  if (type) {
    req = req.eq('playlist.type', type)
  }
  const { data, error }: PostgrestSingleResponse<CategoryPlaylistType[]> = await req

  if (error) {
    throw new Error(error.message)
  }

  const res = data.reduce((acc: PlaylistType[], v: CategoryPlaylistType) => (
    v.playlist ? ([...acc, (v.playlist as PlaylistType)]) : acc
  ), [])

  console.log(res);

  return res
}

export default function usePlaylistsByCategory(categoryId: number, type?: string) {
  return useQuery({
    queryKey: ['playlists', categoryId, type],
    queryFn: () => getPlaylists(categoryId, type),
    staleTime: 60000,
  })
}
